import { AsyncCommand } from "../Command";
import { DynamicDataSet, DynamicFormData} from "@/components/Shared/Dynamicform/DynamicFormData";


export class RuleDynamicShouldDelete extends AsyncCommand {
  
  private dynamicForm: DynamicFormData;  
  private dataSet: DynamicDataSet;
  

  constructor(dynamicForm: DynamicFormData, dataSet: DynamicDataSet ) {
    super();
    this.dynamicForm = dynamicForm;   
    this.dataSet = dataSet;
  }

  public async asyncExecute(): Promise<any> {

    const fieldsHidden = ["RuleDynamicChange","RuleDynamicShouldDelete","RuleDynamicSave"]
    this.dynamicForm.showHideFields(this.dataSet, fieldsHidden , false);    

    const fieldsShown = ["RuleDynamicDelete"]
    this.dynamicForm.showHideFields(this.dataSet, fieldsShown , true)

    const fieldsDisabled = ["Fischart","Anzahl","Gewicht","Laenge","Dauer"]
    this.dynamicForm.enableDisableFields(this.dataSet, fieldsDisabled , false)
   
    return true    
  }
}
